export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";